<template>
  <div class="bg-gray-200 pb-4 md:pb-0">
    <div class="flex container mx-auto p-2 md:p-0">
      <div class="w-1/2 md:py-8 py-4 text-center">
        <p class="text-sm">{{ copyright }}</p>
      </div>
      <div class="w-1/2 md:py-8 py-4 text-center">
        <div class="w-full flex">
          <div class="w-11/12 md:ml-12 ml-4 flex">
            <a class="mr-4 text-sm" href="#"> Terms and Conditions</a>
            <a
              class="text-sm"
              target="_blank"
              href="https://handhcomms.co.uk/privacy-policy/"
              >Privacy Policy</a
            >
          </div>
          <!-- Desktop Mobile -->
          <!--  <div class="w-1/2 md:flex hidden justify-end ">
            <img :src="twitter" width="30" class="mr-1" />
            <img :src="youtube" width="30" class="mr-1" />
            <img :src="facebook" width="30" class="mr-1" />
            <img :src="instagram" width="30" class="mr-1" />
          </div> -->
        </div>
      </div>
    </div>
    <!-- Mobile Media Icons -->
    <!-- <div class="w-full flex md:hidden justify-center">
      <img :src="twitter" width="40" class="mr-1" />
      <img :src="youtube" width="40" class="mr-1" />
      <img :src="facebook" width="40" class="mr-1" />
      <img :src="instagram" width="40" class="mr-1" />
    </div> -->
  </div>
</template>

<script>
export default {
  data() {
    return {
      copyright:
        "Copyright H&H Agency Ltd 2014. Company Reg. 7511770. VAT No 107731823",
      twitter: require("@/assets/img/SVG/twitter.svg"),
      youtube: require("@/assets/img/SVG/youtube.svg"),
      facebook: require("@/assets/img/SVG/facebook.svg"),
      instagram: require("@/assets/img/SVG/instagram.svg")
    };
  }
};
</script>

<style></style>
